import { render, staticRenderFns } from "./NDropdown.vue?vue&type=template&id=38a5b79e"
import script from "./NDropdown.vue?vue&type=script&lang=js"
export * from "./NDropdown.vue?vue&type=script&lang=js"
import style0 from "./NDropdown.vue?vue&type=style&index=0&id=38a5b79e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports